module.exports = __webpack_public_path__ + "img/s-5.f8992ac6.svg";